export const isValidDate = (date: unknown): boolean =>
  date instanceof Date && !isNaN(date.getTime())

export const isValidInput = (value: unknown): boolean =>
  typeof value === 'number' && Number.isInteger(value) && value >= 0
